async function loadSection(section, path, params = {}) {
  const searchParams = new URLSearchParams(params);
  searchParams.set("section_id", section);

  const url = `${window.location.origin}${path}?${searchParams.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load section: ${response.status}`);
    }

    return await response.text();
  } catch (error) {
    console.error("Error loading section:", error);
    return null;
  }
}

class BundleBuilderCollections extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute("section-id");
    this.select = this.querySelector(".collection-navigation-select");
    this.navButtons = this.querySelectorAll(".collection-navigation-button");
    this.init();
  }

  init() {
    if (!this.select) return;

    this.sortProductsByAvailability();

    this.select.addEventListener("change", (event) => {
      const collectionHandle = event.target.value;
      this.updateBundleCollection(collectionHandle);
    });

    this.navButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const collectionHandle = button.dataset.collectionHandle;
        this.updateBundleCollection(collectionHandle);
      });
    });
  }

  sortProductsByAvailability() {
    const gridContainer = this.querySelector(".product-list__inner");
    if (!gridContainer) return;

    const productItems = Array.from(
      gridContainer.querySelectorAll("bundle-builder-product-card"),
    );
    if (productItems.length === 0) return;

    const availableProducts = [];
    const soldOutProducts = [];

    productItems.forEach((item) => {
      const productElement = item.querySelector(".product-item");
      if (
        productElement &&
        productElement.classList.contains("product-item--sold-out")
      ) {
        soldOutProducts.push(item);
      } else {
        availableProducts.push(item);
      }
    });

    const sortedProducts = [...availableProducts, ...soldOutProducts];

    const fragment = document.createDocumentFragment();
    sortedProducts.forEach((item) => {
      fragment.appendChild(item);
    });
    gridContainer.appendChild(fragment);
  }

  async updateBundleCollection(collectionHandle) {
    if (!collectionHandle) return;

    const html = await loadSection(
      this.sectionId,
      `/collections/${collectionHandle}`,
    );
    if (!html) return;

    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, "text/html");
    const newBundleCollections = newDoc.querySelector(
      `bundle-builder-collections[section-id="${this.sectionId}"]`,
    );

    if (newBundleCollections) {
      this.replaceWith(newBundleCollections);
    }
  }
}

customElements.define("bundle-builder-collections", BundleBuilderCollections);
